import { render, staticRenderFns } from "./riskHazardFactorDialog.vue?vue&type=template&id=2da8d0fe&scoped=true"
import script from "./riskHazardFactorDialog.vue?vue&type=script&lang=js"
export * from "./riskHazardFactorDialog.vue?vue&type=script&lang=js"
import style0 from "./riskHazardFactorDialog.vue?vue&type=style&index=0&id=2da8d0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8d0fe",
  null
  
)

export default component.exports